import React from 'react';
import KeyContactDetails from './KeyContactDetails';
import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';

const KeyContact = ({ location }) => {
  const keyContact = location?.state?.keyContact;

  if (!keyContact) {
    return null;
  }

  return (
    <WithNavigation
      title={keyContact.name}
      top={<KeyContactDetails keyContact={keyContact} />}
    />
  );
};

export default KeyContact;
